import { useEffect, useMemo, useRef, useState } from "react";
import { loginUserSelector } from "../../recoil/selectors/loginUserSelector";
import { useRecoilValue } from "recoil";
import {
  RequestGetSettingRequest,
  RequestUpdateSettingRequest,
} from "../../services/OpenAPI";
import { useApiUpdateBaseSetting } from "../api/useApiUpdateBaseSetting";
import { baseSearchOptionsSelector } from "../../recoil/selectors/baseSearchOptionsSelector";
import { useApiGetBaseSetting } from "../api/useApiGetBaseSetting";

export type SearchGenreOption = {
  id: string;
  label: string;
};

export const useSetting = () => {
  const inputRef = useRef<HTMLInputElement>(null);

  const { getBaseSetting } = useApiGetBaseSetting();
  const loginUser = useRecoilValue(loginUserSelector);
  const baseSearchOptions = useRecoilValue(baseSearchOptionsSelector);

  const { updateBaseSetting } = useApiUpdateBaseSetting();

  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [changeSellerIdDialogOpen, setChangeSellerIdDialogOpen] =
    useState(false);
  const [amazonSettingDialogOpen, setAmazonSettingDialogOpen] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState<string>("");
  const [toastSeverity, setToastSeverity] = useState<"success" | "error">(
    "success"
  );

  const [isSeinoCorrection, setIsSeinoCorrection] = useState<boolean>(false);
  const [seinoCorrectionVal, setSeinoCorrectionVal] = useState<string>("");
  const [selectedBaseId, setSelectedBaseId] = useState<number | null>(null);

  const handleCloseToast = () => setToastOpen(false);

  const checkValidate = () => {
    if (
      isSeinoCorrection &&
      (seinoCorrectionVal === "" ||
        seinoCorrectionVal === "0" ||
        Number(seinoCorrectionVal) > 1)
    ) {
      setToastMessage("0より大きく1未満の補正値を入力してください");
      setToastSeverity("error");
      setToastOpen(true);
      return false;
    }
    return true;
  };

  const handleUpdate = async () => {
    if (
      !loginUser ||
      !loginUser.tenantId ||
      !loginUser.id ||
      !loginUser.permissionId
    )
      return;

    const req: RequestUpdateSettingRequest = {
      tenantId: loginUser.tenantId,
      baseId: loginUser.baseId,
      isSeinoCorrection: isSeinoCorrection,
      seinoCorrectionValue: Number(seinoCorrectionVal),
    };
    const result = await updateBaseSetting(req);
    if (result) {
      setToastMessage("更新が完了しました");
      setToastSeverity("success");
      setToastOpen(true);
    } else {
      setToastMessage("更新に失敗しました");
      setToastSeverity("error");
      setToastOpen(true);
    }
  };

  const handleUpdateCheck = () => {
    console.log("aaaa");
    if (!checkValidate()) return;
    handleUpdate();
    // } else {
    //   setChangeSellerIdDialogOpen(true);
    // }
  };

  const handleBaseChange = (baseId: number | null) => {
    setSelectedBaseId(baseId);
    // ここでフィルタ処理やAPI呼び出し
  };

  const baseOptions = useMemo(() => {
    return (
      baseSearchOptions?.map((base) => ({
        label: `${base.name}`,
        id: base.id!,
      })) ?? []
    );
  }, [baseSearchOptions]);

  const fetchSettingData = async () => {
    const req: RequestGetSettingRequest = {
      tenantId: loginUser?.tenantId,
      baseId: Number(selectedBaseId),
    };
    const result = await getBaseSetting(req);
    if (result) {
      setIsSeinoCorrection(result.isSeinoCorrection ?? false);
      setSeinoCorrectionVal(String(result.seinoCorrectionValue ?? ""));
    }
  };

  useEffect(() => {
    if (selectedBaseId === null) {
      setIsSeinoCorrection(false);
      setSeinoCorrectionVal("");
      return;
    }
    fetchSettingData();
  }, [selectedBaseId]);

  useEffect(() => {
    fetchSettingData();
  }, []);

  return {
    inputRef,
    handleUpdateCheck,
    handleUpdate,
    detailDialogOpen,
    setDetailDialogOpen,
    toastOpen,
    toastMessage,
    toastSeverity,
    handleCloseToast,
    changeSellerIdDialogOpen,
    setChangeSellerIdDialogOpen,
    amazonSettingDialogOpen,
    setAmazonSettingDialogOpen,
    isSeinoCorrection,
    setIsSeinoCorrection,
    seinoCorrectionVal,
    setSeinoCorrectionVal,
    baseOptions,
    selectedBaseId,
    handleBaseChange,
  };
};
